import { render, staticRenderFns } from "./benefitPlan.vue?vue&type=template&id=51228860&"
import script from "./benefitPlan.vue?vue&type=script&lang=js&"
export * from "./benefitPlan.vue?vue&type=script&lang=js&"
import style0 from "./benefitPlan.vue?vue&type=style&index=0&id=51228860&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports